var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[_vm.preClass, 'container']},[(!_vm.smallScale)?_c('base-table',{attrs:{"data":_vm.addTaxData,"title":"*增值税"}}):_vm._e(),_vm._v(" "),_c('base-table',{attrs:{"data":_vm.incomTaxData,"title":"*企业所得税"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a93c81a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/financial-report/tax-analyse/index.vue
// module id = null
// module chunks = 